<template>
  <div class="client-register">
    <div class="register-img">
      <img class="logo-img" src="../../assets/img/index/logo_new.svg" alt="">
      <img class="dec-img" :src="showText.img" alt="">
      <div class="register-dec">
        <h1>{{showText.slogan}}</h1>
        <div class="register-dec-content">
          <div class="dec-item" v-for="(item, index) in showText.subSlogans" :key="index">
            <img src="../../assets/img/register/icon_check.svg" alt=""><span>{{item}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="register-form" v-if="!successRegister">
      <h1>{{showText.title}}</h1>
      <el-form ref="registerForm" label-position="top" status-icon :model="registerForm" :rules="registerRules">
        <el-form-item label="您的称呼" prop="name">
          <el-input v-model="registerForm.name" :maxlength="20" class="form-input name"
                    placeholder="请输入您的姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input v-model.number="registerForm.mobile" :maxlength="15" class="form-input mobile"
                    placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="validate" class="validate-code">
          <el-input :maxlength="6" v-model="registerForm.validate" class="form-input validate" placeholder="请输入手机验证码">
          </el-input>
          <el-button :class="`code-button`" :disabled="!!smsCodeRemain" @click="getSmsCode">{{smsCodeRemain > 0 ? smsCodeRemain + '秒': '获取验证码' }}</el-button>
        </el-form-item>
        <!-- <el-form-item label="验证码" prop="validate" class="validate-code">
          <el-input :maxlength="4" v-model="registerForm.validate" class="form-input validate" placeholder="请输入图中字符">
          </el-input>
          <img class="validate-img"
               :src="validateUrl" alt="请求失败,请检查网络"/>
          <span @click="changeCode">看不清?换一张</span>
        </el-form-item> -->
        <el-form-item label="企业名称" prop="company">
          <el-input v-model="registerForm.company" :maxlength="20" class="form-input company"
                    placeholder="请输入企业名称"></el-input>
        </el-form-item>
      </el-form>
      <el-alert v-if="tipList.show"
                :title="tipList.title"
                :type="tipList.type"
                center
                show-icon>
      </el-alert>
      <el-button :class="`submit-button ${errorStyle}`" @click="submitMessage"
                 :disabled="canSubmit">立即注册
      </el-button>
    </div>
    <div class="register-success" v-if="successRegister">
      <div class="success-title"><img src="../../assets/img/register/icon_check.svg" alt="恭喜您，注册成功">
        <h1>恭喜您，注册成功！</h1>
      </div>
      <p>甄云顾问将会联系您并为您提供专业的讲解与演示</p>
      <p>您可关闭当前页面，继续浏览甄云产品！</p>
    </div>
  </div>
</template>

<script>
import { Loading } from 'element-ui'
import solutionIndex from '../../assets/js/solutionIndex.json'

const defaultShowText = {
  img: require('../../assets/img/register/illustration.png'),
  title: '免费体验招投标管理',
  slogan: '甄云，让企业采购管理更简单',
  subSlogans: ['0元免费体验产品', '获取产品价格与定制化实施方案', '标杆企业的采购管理案例', '邀约参与10+ 场VIP采购峰会']
}

export default {
  name: 'index',
  data () {
    var nameValidate = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('姓名不能为空'))
      }
      callback()
    }
    var mobileValidate = (rule, value, callback) => {
      var isMob = /^[1]([3-9])[0-9]{9}$/ // 手机号码
      if (!value) {
        return callback(new Error('联系方式不能为空'))
      }
      if (isMob.test(value)) {
        callback()
      } else {
        callback(new Error('联系方式格式错误'))
      }
    }
    var emailValidate = (rule, value, callback) => {
      var isEmail = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/ // 邮箱
      if (!value) {
        return callback(new Error('邮箱不能为空'))
      }
      if (isEmail.test(value)) {
        callback()
      } else {
        callback(new Error('邮箱格式错误'))
      }
    }
    var codeValidate = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('验证码不能为空'))
      }
      callback()
    }
    // var codeValidate2 = (rule, value, callback) => {
    //   this.$api.post('/base/verifySmsCode', { code: value }, (r) => {
    //     if (r.code === 0) {
    //       callback()
    //     } else {
    //       this.changeCode()
    //       callback(new Error('验证码错误！'))
    //     }
    //   })
    // }
    return {
      solutionIndex: solutionIndex.data,
      visible: false,
      successFlag: false,
      IsDetileFlag: false,
      canSubmit: false,
      successRegister: false,
      loadingArray: [],
      errorStyle: '',
      registerForm: {
        name: '',
        mobile: '',
        validate: '',
        email: '',
        company: ''
      },
      registerRules: {
        name: [
          { validator: nameValidate, trigger: 'blur', required: true }
        ],
        mobile: [
          { validator: mobileValidate, trigger: 'blur', required: true }
        ],
        validate: [
          { validator: codeValidate, trigger: 'blur', required: true }
          // { validator: codeValidate2, trigger: 'submit' }
        ],
        email: [
          { validator: emailValidate, trigger: 'blur', required: true }
        ]
      },
      validateUrl: this.$global.globalPath + 'api/document/getcode',
      showText: defaultShowText,
      meta: '',
      tipList: { title: '', type: '', show: false },
      smsCodeTimer: null,
      smsCodeRemain: 0
    }
  },
  methods: {
    submitMessage () {
      this.loadingArray = []
      this.$refs['registerForm'].validate((valid) => {
        if (valid) {
          this.callRegister()
        } else {
          this.canSubmit = false
          return false
        }
      })
    },
    setTip (title, type) {
      this.tipList.title = title
      this.tipList.type = type
      this.tipList.show = true
    },
    getSmsCode () {
      let value = this.registerForm.mobile
      var isMob = /^[1]([3-9])[0-9]{9}$/ // 手机号码
      if (!value) {
        this.setTip('联系方式不能为空', 'error', true)
        return
      }
      if (!isMob.test(value)) {
        this.setTip('联系方式格式错误', 'error', true)
        return
      }

      this.$api.post('/base/getSmsCode', {
        mobile: value
      }, r => {
        if (r.code === 0) {
          this.setTip('短信发送发送成功', 'success', true)
          this.smsCodeRemain = 60
          this.smsCodeTimer = setInterval(() => {
            this.smsCodeRemain--
            if (this.smsCodeRemain <= 0) {
              clearInterval(this.smsCodeTimer)
            }
          }, 1000)
        } else {
          this.setTip('短信发送发送失败', 'error', true)
        }
      })
    },
    callRegister () {
      let loading = Loading.service({
        target: '.el-dialog--center',
        text: '正在提交您的信息，请稍候'
      })
      this.loadingArray.push(loading)
      let form = {
        code: this.$route.query.code || null,
        mobile: this.registerForm.mobile,
        name: this.registerForm.name,
        company: this.registerForm.company,
        validate: this.registerForm.validate,
        registerpage: this.meta
      }
      this.$api.post('/base/register', form, (r) => {
        if (r.code === 0) {
          this.IsDetileFlag = true
          this.loadingArray.forEach(item => item.close())
          this.tipList.title = '注册成功,稍后会有顾问与您联系'
          this.tipList.show = true
          this.tipList.type = 'success'
          this.successRegister = true
          this.loadingArray.forEach(item => {
            item = null
          })
          setTimeout(() => {
            this.visible = false
          }, 1500)
        } else if (r.code === 10) {
          this.errorStyle = 'error-button'
          this.tipList.title = r.data
          this.tipList.show = true
          this.tipList.type = 'error'
        } else {
          this.loadingArray.forEach(item => item.close())
          this.tipList.title = r.data || '注册失败'
          this.tipList.show = true
          this.tipList.type = 'error'
          setTimeout(() => {
            this.visible = false
          }, 1500)
        }
      })
    },
    changeCode () {
      let a = this.validateUrl
      this.validateUrl = ''
      this.$nextTick(() => {
        this.validateUrl = a
      })
    },
    refreshText () {
      const sourceId = this.$route.query.sourceId
      const from = this.$router.resolve({ name: sourceId })
      this.meta = from.resolved ? from.resolved.meta.content : ''
      if (this.$route.query.currentCode) {
        const solutionList = this.solutionIndex.find((item) => {
          return item.code === this.$route.query.currentCode
        })
        this.showText.title = solutionList.title
      } else {
        if (sourceId === 'Solution') {
          this.showText.title = '免费体验采购数字化管理'
        } else {
          this.showText.title = from.resolved ? from.resolved.meta.title : ''
        }
      }
    }
  },
  created () {
    this.refreshText()
  }
}
</script>

<style lang="scss">
  .client-register {
    width: 100%;
    display: flex;
    height: 789px;


    .register-img {
      width: 800px;
      background: url("../../assets/img/register/bg.svg") no-repeat;
      padding: 64px 138px 0 72px;

      .dec-img {
        width: 590px;
        height: 342px;
      }

      .register-dec {
        margin-top: 48px;

        h1 {
          font-size: 22px;
          color: #414447;
          letter-spacing: 0;
        }

        .register-dec-content {
          margin: 22px auto 109px;
          width: 604px;
          height: 100px;

          .dec-item {
            float: left;
            padding: 10px 0 17.5px 11px;
            display: flex;
            align-items: center;
            width: 275px;
            height: 44px;
            background-image: linear-gradient(270deg, rgba(236, 245, 250, 0.00) 0%, #E9F3FB 100%);

            span {
              margin-left: 15px;
            }
          }

          .dec-item:nth-child(odd) {
            margin: 20px 27px 0 0;
          }

          .dec-item:nth-child(even) {
            margin: 20px 0 0 27px;
          }
        }
      }
    }

    .register-form {
      width: 380px;
      margin: 0 auto;

      .el-form-item {
        margin-bottom: 30px;
      }


      h1 {
        margin: 74px 0 60px 0;
        font-size: 28px;
        color: #414447;
        letter-spacing: 0;
      }

      .validate-code {
        .validate {
          width: 201px;
        }

        img {
          margin-left: 12px;
          width: 101px;
          height: 40px;
        }

        span {
          margin-left: 5px;
          font-size: 12px;
          color: #414447;
          letter-spacing: 0.55px;
          text-decoration: underline;
        }
      }

      .el-form-item__label::before {
        display: none;
      }

      .el-form-item__label {
        padding: 0 0 8px 0;
        font-size: 14px;
        color: #414447;
        letter-spacing: 0.64px;
        line-height: 1;
      }

      .submit-button {
        margin-top: 30px;
        width: 382px;
        height: 40px;
        background: #29BECE;
        font-size: 14px;
        color: #FFFFFF;
        letter-spacing: 0;
        border-radius: 0 !important;
      }
      
      .code-button {
        width: 160px;
        height: 40px;
        background: #29BECE;
        color: #FFFFFF;
        margin-left: 15px;
        span {
          color: #fff;
          text-decoration: none;
        }
      }

      .error-button {
        background: #B8BCC9;
      }
    }

    .register-success {
      width: 369px;
      margin: 277px auto 322px;

      .success-title {
        display: flex;
        align-items: center;

        img {
          width: 35px;
          height: 35px;
        }

        h1 {
          margin-left: 12px;
          font-size: 28px;
          color: #414447;
          letter-spacing: 0;
        }
      }

      p {
        margin-top: 20px;
        font-size: 16px;
        color: #414447;
        letter-spacing: 0.73px;
      }
    }

  }


</style>



// WEBPACK FOOTER //
// index.vue?1d28917e